module.exports = __webpack_public_path__ + "static/media/received_1005565146251894.c1582719.jpeg";